import axios from 'axios'

const instance = axios.create({
  baseURL: 'https://porto-seguro-r-financeiros-stg.uc.r.appspot.com',
})

instance.defaults.headers['X-API-Key'] = '888a9916-4fba-47f5-97f5-2f411c4e318e'

export default instance
